import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommMessageTable extends Layout {
	sourceMcMessage: DataSource;
	tableMcMessage: Table;
}
